export default __webpack_public_path__ + "static/media/Fish out of Water 3D.7eb7927d.png";